<template>

    <div class="page-center content-load">

        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-xl-6 col-xl-offset-3 col-md-6 col-md-offset-3">

                    <div class="login-register-page">
                        
                        <div class="welcome-text">
                            <h3>Cadastre-se abaixo!</h3>
                            <span>
                                Já possui um cadastro? 
                                <br>
                                <router-link :to="{'name': 'Login'}">
                                    <b><u>Faça login aqui</u>.</b>
                                </router-link>
                            </span>
                        </div>

                        <form method="post" id="register-account-form" v-on:submit.prevent="submit" novalidate="">
                            
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">                                                               
                            
                                            <div class="col-lg-12 col-xs-12">    
                                                <div class="section-headline margin-top-0 margin-bottom-0">
                                                    <h5>Nome completo</h5>
                                                </div>  
                                            </div>
                                            <div class="col-lg-11 col-xs-12">
                                                <div class="input-with-icon-left">
                                                    <i class="material-icons">info</i>
                                                    <input type="text" class="input-text with-border" autocomplete="new-password" v-model="form.nome" name="nome" autocapitalize="words" id="nome" placeholder="Informe seu nome completo" required/>
                                                </div>          
                                            </div>      
                                            <div class="col-lg-12 col-xs-12">
                                                <div class="section-headline margin-top-0 margin-bottom-0">
                                                    <h5>E-mail</h5>
                                                </div>
                                            </div>                                
                                            <div class="col-lg-10 col-xs-12">
                                                <div class="input-with-icon-left">
                                                    <i class="material-icons">email</i>
                                                    <input type="email" class="input-text with-border" autocomplete="new-password" v-model="form.email" name="email" id="email" placeholder="Informe seu e-mail" required/>
                                                </div>              
                                            </div>  
                                            <div class="col-lg-12 col-xs-12">
                                                <div class="section-headline margin-top-0 margin-bottom-0">
                                                    <h5>Telefone</h5>
                                                </div>
                                            </div>                                
                                            <div class="col-lg-7 col-xs-10">
                                                <div class="input-with-icon-left">
                                                    <i class="material-icons">phone</i>
                                                    <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border input-text" placeholder="Informe seu telefone" autocomplete="new-password" v-model="form.telefone" />
                                                </div>
                                            </div>
                                            <div class="col-lg-12 col-xs-12">
                                                <div class="section-headline margin-top-0 margin-bottom-0">
                                                    <h5>CPF</h5>
                                                </div>
                                            </div>                                
                                            <div class="col-lg-7 col-xs-10">
                                                <div class="input-with-icon-left">
                                                    <i class="material-icons">verified_user</i>
                                                    <the-mask :mask="['###.###.###-##']" type="tel" class="input-text with-border" autocomplete="new-password" v-model="form.doc" placeholder="Informe seu CPF" required />
                                                </div>                      
                                            </div>
                                            <div class="col-lg-12 col-xs-12">
                                                <div class="section-headline margin-top-0 margin-bottom-0">
                                                    <h5>Data de nascimento</h5>
                                                </div>
                                            </div>                                
                                            <div class="col-lg-6 col-xs-10 margin-bottom-15">
                                                <div class="input-with-icon-left">
                                                    <i class="material-icons">event</i>
                                                    <the-mask :mask="['##/##/####']" :masked="true" type="tel" class="input-text with-border" autocomplete="new-password" v-model="form.dataNascimento" placeholder="___ /____ /_____" required />
                                                </div>                      
                                            </div>

                                            <div class="col-lg-12 col-xs-12">
                                                <div class="section-headline margin-top-0 margin-bottom-0">
                                                    <h5>Senha</h5>
                                                </div>
                                            </div>
                                            <div class="col-lg-9 col-xs-10">
                                                <div class="input-with-icon-left" title="Pelo menos 8 caracteres" data-tippy-placement="bottom">
                                                    <i class="material-icons">lock</i>
                                                    <input type="password" class="input-text with-border" autocomplete="new-password" v-model="form.senha" name="senha" id="password-register" placeholder="Informe uma senha" required/>
                                                </div>
                                            </div>
                                            <div class="col-lg-9 col-xs-10">
                                                <div class="input-with-icon-left">
                                                    <i class="material-icons">lock</i>
                                                    <input type="password" class="input-text with-border" autocomplete="new-password" v-model="form.senhaConfirmacao" name="senhaConfirmacao" id="password-repeat-register" placeholder="Repita sua senha" required/>
                                                </div>
                                            </div>
            <!--                                 <div class="col-lg-12 col-xs-12">
                                                <div class="checkbox margin-top-30">
                                                    <input type="checkbox" id="termos" autocomplete="new-password" v-model="termos">
                                                    <label for="termos"><span class="checkbox-icon"></span>  Ao prosseguir você concorda com os <a target="_blank" ><b>Termos de Uso</b></a>.</label>
                                                </div>
                                            </div> -->
                                            <div class="col-lg-12 col-xs-12">
                                                <button class="button full-width margin-top-10 margin-bottom-30" v-bind:class="{'disabled': loading.submit || !termos}" type="submit">
                                                    <i class="material-icons">lock</i>
                                                    <span v-show="!loading.submit">Cadastrar</span>
                                                    <span v-show="loading.submit">Cadastrando</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            

                        </form>

                        
                    </div>

                </div>
            </div>
        </div>  
    </div>
</template>

<script>
export default {
    name:                           'Cadastro',
    data () {
        var self                    = this;
        return {
            termos:                 true,
            loading: {
                "submit":           false,
            },
            form: {
                "nome":             null,
                "email":            null,
                "tipo":             "contratante",
                "telefone":         null,
                "dataNascimento":   null,
                "senha":            null,
                "senhaConfirmacao": null,
                "dispositivo":      self.$root.mobile.osName,
                "cidade":           null,
                "estado":           null,
                "localizacao":      null
            }
        }
    },
    methods: {
        submit: function(e) {
            var self            = this;
            if (!self.termos) return false;
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
            axios.post("api/cadastro.php", self.form)
            .then(response => {
                // self.loading.submit = false;
             
                if (response.data.user) {
                    self.$root.setUser(response.data.user).then(function() {
                        // self.$router.push({"name": "Dashboard"});
                        setTimeout(function() {
                            window.location.reload();
                        }, 200);
                    })
                } else {
                    loading.hide();
                }
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        }
    },
    mounted: function() {
        loading.hide();
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
    .current-page-cadastro .loading {
        top: 0px !important;
    }    
    .page-cadastro #wrapper {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }
    .page-cadastro .container {
        margin-top: 35px !important;
        padding-left: 20px;
        padding-right: 20px;
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cadastro.vue